var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.875C0 17.4963 0.503683 18 1.125 18H16.875C17.4963 18 18 17.4963 18 16.875C18 16.2537 17.4963 15.75 16.875 15.75H1.125C0.503683 15.75 0 16.2536 0 16.875ZM12.9859 6.23594C12.698 6.23594 12.4101 6.12611 12.1904 5.90642L10.125 3.84099V12.5157C10.125 13.137 9.62132 13.6407 9 13.6407C8.37868 13.6407 7.875 13.137 7.875 12.5157V3.84099L5.80957 5.90642C5.37022 6.34577 4.65792 6.34577 4.21857 5.90642C3.77923 5.46707 3.77923 4.75477 4.21857 4.31542L8.20452 0.329511C8.64387 -0.109837 9.35617 -0.109837 9.79552 0.329511L13.7814 4.31542C14.2208 4.75477 14.2208 5.46707 13.7814 5.90642C13.5617 6.12611 13.2738 6.23594 12.9859 6.23594Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpLoad);
export default __webpack_public_path__ + "static/media/IconUpLoad.76e7f8abb6e6bb67f56a3fc183323f5c.svg";
export { ForwardRef as ReactComponent };